import { render, staticRenderFns } from "./MenuManagement.vue?vue&type=template&id=27b6ebb4&scoped=true"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"
import style0 from "./MenuManagement.vue?vue&type=style&index=0&id=27b6ebb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6ebb4",
  null
  
)

export default component.exports